enum VehicleType {
	Resident = 0,
	Visitor = 1,
	Temporary
}

export default VehicleType;
